import React from "react";
import textConfig from "../utils/text";

export default function Frame13(props: any){

	let {  Svg, svgProps, children, viewBox, backgroundColor, frameBody } = props;
	let { path, text_1 } = props, [ __html, { textColor, style } ] = textConfig(text_1, frameBody);
	
	return <Svg xmlns="http://www.w3.org/2000/svg" {...svgProps} viewBox="0 0 1090 1576.337">
		<defs>
			<clipPath id="myClip">
				<rect width={1000} height={1000} rx={30}/>
			</clipPath>
		</defs>
		<g>
			<rect fill={backgroundColor} x={-5} y={-5} width="992" height="986" rx="20" transform="translate(49 49)"/>
			<path fill={frameBody} fill-rule="evenodd" clip-rule="evenodd" d="M1050 0C1072.09 0 1090 17.9086 1090 40V1044C1090 1066.09 1072.09 1084 1050 1084H40C17.9086 1084 0 1066.09 0 1044V40C0 17.9086 17.9086 0 40 0H1050ZM64 44C52.9543 44 44 52.9543 44 64V1010C44 1021.05 52.9543 1030 64 1030H1016C1027.05 1030 1036 1021.05 1036 1010V64C1036 52.9543 1027.05 44 1016 44H64Z"/>
			<path fill={frameBody} d="M1040.76 1576.33H48.407C21.673 1576.33 0 1554.26 0 1527.03V1305.13C0 1277.9 21.673 1255.82 48.407 1255.82H418.723C420.321 1255.87 421.909 1255.57 423.374 1254.93C424.839 1254.29 426.144 1253.33 427.194 1252.12L536.111 1141.17C537.221 1140.06 538.541 1139.17 539.995 1138.56C541.449 1137.96 543.008 1137.65 544.583 1137.65C546.157 1137.65 547.716 1137.96 549.17 1138.56C550.624 1139.17 551.944 1140.06 553.054 1141.17L661.97 1252.12C663.02 1253.33 664.325 1254.28 665.79 1254.92C667.255 1255.56 668.843 1255.87 670.441 1255.82H1040.76C1067.49 1255.82 1089.16 1277.9 1089.16 1305.13V1527.03C1089.16 1554.26 1067.49 1576.33 1040.76 1576.33Z"/>
		</g>
		<g transform={"translate(45 43)"}>
			<g clipPath="url(#myClip)">{children}</g>
		</g>
		<g transform={"translate(45,1310) scale(1)"}>
			<svg xmlns="http://www.w3.org/2000/svg" width={1000} height={200} viewBox={viewBox}>
				<defs>
					<clipPath id="myClip">
						<path d={path}/>
					</clipPath>
				</defs>
				<foreignObject x="0" y="0" width="1000" height="200" clipPath="url(#myClip)">
					<div
						dangerouslySetInnerHTML={{__html}}
						style={{
							width: 'calc(100%)', height: 'calc(100%)',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							...style, color: textColor
						}}
					/>
				</foreignObject>
			</svg>
		</g>
	</Svg>
}